import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/assetComment/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/assetComment/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/assetComment/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/assetComment/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/assetComment/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/assetComment/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/assetComment/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/assetComment/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/assetComment/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/assetComment/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/assetComment/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/assetComment/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function loadAssetComments(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/asset-comments', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ASSET_COMMENT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadAssetComment(assetCommentId){
  const options = new URLSearchParams([
    ['includes', 'details'],
  ])

  const promise = api(`/v1/asset-comments/${assetCommentId}`, options)
    .then(data => data)

  return promise
}

export function createAssetComment(assetComment, options){
  const config = {
    method: 'POST',
    data: assetComment,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/asset-comments', options, config)
      .then(({ data }) => loadAssetComment(data))
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ASSET_COMMENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateAssetComment(assetComment, options){
  const config = {
    method: 'PUT',
    data: assetComment,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/asset-comments/${assetComment.id}`, options, config)
      .then(({ data }) => {
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteAssetComment(assetCommentId){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v1/asset-comments/${assetCommentId}`, {}, config)
      .then(({ data }) => {
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action
  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors,
        loaded: false,
        loading: false,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
